import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const adminCommission = createAsyncThunk("user/adminCommission", async (payload) => {

  const response = await api.post("admin/commission/admin-commission", payload);
 
  return response.data;
});

const adminCommissionSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminCommission.pending, (state) => {
        state.loading = true;
      })
      .addCase(adminCommission.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
        toast.success(action.payload.message);
      })
      .addCase(adminCommission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default adminCommissionSlice.reducer;
